import React, {
    createContext,
    useContext,
    useEffect,
    useState,
    useRef,
    useCallback,
  } from "react";
  import { BACKEND_ROOT_URL } from "../api";
  import { useCookies } from "../hooks/useCookies";
  import { useSocket } from "../Context/SockerContext";

  
  
  const QuestionsContext = createContext();
  
  export const useQuestion = () => {
    const context = useContext(QuestionsContext);
    if (!context) {
      throw new Error("useQuestion must be used within a QuestionProvider");
    }
    return context;
  };
  
  export default function QuestionProvider({ children }) {
    const { getCookie } = useCookies();
    const [updateQuestion, setUpdateQuestion] = useState();
    const token = getCookie("token");
    const { socket } = useSocket();
    const userId = getCookie('userId');
    const [loading, setLoading] = useState(true);
  
    const hasFetchedRef = useRef(false);


    useEffect(() => {
      if (!socket) return;
      socket.on("user_socket_emit", data => {
        if (data?.userId === userId && data?.event === "fetch_user_data") {
          fetchUpdatedData();
        }
      });
    }, [socket,userId]);
  
    const fetchUpdatedData = useCallback(async () => {
      if (!token) return;
      setLoading(true);

      try {
        const response = await fetch(
          `${BACKEND_ROOT_URL}/api/v2/user/getQuestionUpdateRequest`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.ok) {
          const data = await response.json();
          if (data?.data) {
            setUpdateQuestion(data.data);
            return { data: data.data };
          }
          else{
              setUpdateQuestion(null);
              return false
           
          }
        }
      } catch (error) {
        console.error("Error fetching updated questions:", error);
      }
      finally {
        setLoading(false);
      }
    }, [token]);
  
    useEffect(() => {
      if (!hasFetchedRef.current) {
        fetchUpdatedData();
        hasFetchedRef.current = true;
      }
    }, [fetchUpdatedData]);
  
    
    return (
      <QuestionsContext.Provider
        value={{ updateQuestion, fetchUpdatedData,loading }}
      >
        {children}
      </QuestionsContext.Provider>
    );
  }
  